(function(){
    // Prevent multiple event listener attachments
    if (window.quickAddEventListenersInitialized) {
      return;
    }
    window.quickAddEventListenersInitialized = true;
  
    // Escapes HTML meta-characters so dynamic values are safe to embed in innerHTML.
    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#x27;');
    }
  
    // Returns true only for http/https URLs and relative paths.
    function isValidUrl(url) {
      if (!url) return false;
      // Allow relative URLs
      if (url.startsWith('/') || url.startsWith('./') || url.startsWith('../')) return true;
      try {
        const parsed = new URL(url, window.location.origin);
        return parsed.protocol === 'https:' || parsed.protocol === 'http:';
      } catch (_) {
        return false;
      }
    }

    function sanitizeImageUrl(url) {
      if (typeof url !== 'string') return null;
      const stripped = url.trim();
      if (!stripped) return null;

      try {
        
        const parsed = new URL(stripped, window.location.origin);
        
        if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
          return parsed.href;
        }
      } catch (e) {
      }

      return null;
    }
    // ────────────────────────────────────────────────────────────────────────
  
    // Function to adjust popup height dynamically based on content
    function adjustPopupHeight(popup) {
      const popupContent = popup.querySelector('.popup-content');
      const popupScroll = popup.querySelector('.popup-scroll');
      
      if (!popupContent || !popupScroll) return;
      
      // Calculate content height
      setTimeout(() => {
        const sizeOptions = popup.querySelectorAll('[data-option="Size"] .custom-size-ul-value').length;
        const lengthOptions = popup.querySelectorAll('[data-option="Length"] .custom-size-ul-value').length;
        
        // Dynamic height based on options count
        const totalOptions = sizeOptions + lengthOptions;
        
        // Remove previous size classes
        popupContent.classList.remove('compact', 'medium', 'large');
        
        if (totalOptions <= 10) {
          popupContent.classList.add('compact');
          // Don't override height - let CSS handle it for proper centering
          // popupContent.style.height = 'auto';
        } else if (totalOptions <= 20) {
          popupContent.classList.add('medium');
          popupContent.style.height = '';
        } else {
          popupContent.classList.add('large');
          popupContent.style.height = '';
        }
        
        console.log(`Popup adjusted: ${totalOptions} options (Size: ${sizeOptions}, Length: ${lengthOptions})`);
      }, 50);
    }
  
    // Function to mark unavailable size/length options
    function markUnavailableOptions(popup, productId) {
      const variantEl = document.getElementById(`ProductVariants-${productId}`);
      if (!variantEl) {
        console.log('No variant data found for product', productId);
        return;
      }
  
      let variants = [];
      try {
        variants = JSON.parse(variantEl.textContent);
      } catch (err) {
        console.error('Invalid variant JSON for product', productId, err);
        return;
      }
  
      if (!Array.isArray(variants)) {
        console.error('Variants is not an array for product', productId);
        return;
      }
  
      console.log('Product', productId, 'has', variants.length, 'variants');
  
      // Mark unavailable sizes
      const sizeOptions = popup.querySelectorAll('[data-option="Size"] .custom-size-ul-value');
      sizeOptions.forEach((sizeEl) => {
        const sizeValue = sizeEl.textContent.trim();
        // Check if any variant with this size is available
        const hasAvailableVariant = variants.some((v) => {
          return v.option1 === sizeValue && v.available;
        });
        
        if (!hasAvailableVariant) {
          sizeEl.classList.add('unavailable');
          console.log('Size', sizeValue, 'is unavailable');
        } else {
          sizeEl.classList.remove('unavailable');
          console.log('Size', sizeValue, 'is available');
        }
      });
  
      // Mark unavailable lengths
      const lengthOptions = popup.querySelectorAll('[data-option="Length"] .custom-size-ul-value');
      lengthOptions.forEach((lengthEl) => {
        const lengthValue = lengthEl.textContent.trim();
        // Check if any variant with this length is available
        const hasAvailableVariant = variants.some((v) => {
          return v.option2 === lengthValue && v.available;
        });
        
        if (!hasAvailableVariant) {
          lengthEl.classList.add('unavailable');
          console.log('Length', lengthValue, 'is unavailable');
        } else {
          lengthEl.classList.remove('unavailable');
          console.log('Length', lengthValue, 'is available');
        }
      });
    }
  
    // Use event delegation for dynamically loaded content
    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('open-popup')) {
        e.preventDefault();
        const productId = e.target.getAttribute('data-product-id');
        const popup = document.getElementById(`custom-popup-${productId}`);
        const sizeOrLengthValues = popup.querySelectorAll('.custom-size-ul-value');
        document.querySelectorAll('.popup-overlay').forEach((p) => {
          p.style.display = 'none';
        });
        if (sizeOrLengthValues.length > 0) {
          // Mark unavailable options before showing the popup
          markUnavailableOptions(popup, productId);
          
          const isMobile = window.innerWidth <= 768;
          if (isMobile) {
            popup.classList.add('mobile-full');
            document.body.style.overflow = 'hidden';
            // Move popup to body for true full-screen (not constrained by parent containers)
            if (popup.parentNode !== document.body) {
              document.body.appendChild(popup);
            }
            // Remove any inline styles that might interfere with centering
            popup.style.display = '';
            popup.style.left = '';
            popup.style.right = '';
            popup.style.top = '';
            popup.style.bottom = '';
            popup.style.transform = '';
            const popupContent = popup.querySelector('.popup-content');
            if (popupContent) {
              popupContent.style.left = '';
              popupContent.style.right = '';
              popupContent.style.top = '';
              popupContent.style.bottom = '';
              popupContent.style.transform = '';
              // Keep margin for centering but clear if it's set incorrectly
              if (popupContent.style.margin && !popupContent.style.margin.includes('auto')) {
                popupContent.style.margin = '';
              }
            }
            popup.classList.add('show');
          } else {
            popup.classList.remove('mobile-full', 'show');
            document.body.style.overflow = '';
            popup.style.display = 'block';
          }
          adjustPopupHeight(popup); // Adjust height dynamically
          
          // Hide slider arrows for this product when popup is open
          const productArrows = document.querySelectorAll(`.product-slider-nav[data-product-id="${productId}"]`);
          productArrows.forEach(arrow => {
            arrow.style.display = 'none';
            arrow.style.opacity = '0';
            arrow.style.zIndex = '-1';
          });
          
          // Show product info section on mobile full-screen
          if (window.innerWidth <= 768) {
            const productInfo = popup.querySelector('.popup-product-info');
            if (productInfo) {
              productInfo.style.display = 'block';
            }
            // Bind thumbnail click to swap main image with full-size version
            if (productInfo) {
              const thumbsContainer = productInfo.querySelector('.thumbs');
              const thumbImages = productInfo.querySelectorAll('[data-thumb]');
              const mainImg = productInfo.querySelector('.popup-product-image');
              
              // Thumbnail click handler
              thumbImages.forEach((thumb, index) => {
                thumb.addEventListener('click', function(){
                  // Get full-size image URL
                  const fullImageUrl = this.getAttribute('data-full-image') || this.getAttribute('src');
                  
                  // Update main image only when the URL is safe (no javascript:/data: schemes)
                  const sanitizedUrl = sanitizeImageUrl(fullImageUrl);
                  if (mainImg && sanitizedUrl) {
                    mainImg.src = sanitizedUrl;
                  }
                  
                  // Update active state
                  thumbImages.forEach(img => img.classList.remove('active'));
                  this.classList.add('active');
                  
                  // Scroll thumbnail into view
                  this.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
                });
              });
              
              // Thumbnail slider navigation
              const prevBtn = productInfo.querySelector('.thumbs-prev');
              const nextBtn = productInfo.querySelector('.thumbs-next');
              
              // Function to check if scrolling is needed
              function updateNavButtons() {
                if (!thumbsContainer) return;
                const hasOverflow = thumbsContainer.scrollWidth > thumbsContainer.clientWidth;
                
                if (prevBtn) prevBtn.style.display = hasOverflow ? 'flex' : 'none';
                if (nextBtn) nextBtn.style.display = hasOverflow ? 'flex' : 'none';
              }
              
              if (prevBtn && thumbsContainer) {
                prevBtn.addEventListener('click', function(e) {
                  e.preventDefault();
                  e.stopPropagation();
                  thumbsContainer.scrollBy({ left: -66, behavior: 'smooth' }); // 56px + 10px gap
                });
              }
              
              if (nextBtn && thumbsContainer) {
                nextBtn.addEventListener('click', function(e) {
                  e.preventDefault();
                  e.stopPropagation();
                  thumbsContainer.scrollBy({ left: 66, behavior: 'smooth' }); // 56px + 10px gap
                });
              }
              
              // Check if navigation is needed after images load
              setTimeout(updateNavButtons, 100);
              thumbsContainer.addEventListener('scroll', updateNavButtons);
              window.addEventListener('resize', updateNavButtons);
            }
            // Inject mobile actions (qty + buttons) once
            if (!popup.querySelector('.mobile-actions')) {
              const actions = document.createElement('div');
              actions.className = 'mobile-actions';

              // Quantity row
              const qtyRow = document.createElement('div');
              qtyRow.style.cssText = 'display:flex; text-align:center; gap:12px;';

              const qtyLabel = document.createElement('div');
              qtyLabel.style.cssText = 'font-weight:600; align-self:center; font-size:14px;';
              qtyLabel.textContent = 'Quantity';

              const qtySelector = document.createElement('div');
              qtySelector.className = 'qty-selector';

              const btnDecrease = document.createElement('button');
              btnDecrease.type = 'button';
              btnDecrease.className = 'qty-decrease';
              btnDecrease.setAttribute('aria-label', 'Decrease quantity');
              btnDecrease.textContent = '-';

              const qtyInput = document.createElement('input');
              qtyInput.type = 'number';
              qtyInput.className = 'qty-input';
              qtyInput.min = '1';
              qtyInput.value = '1';
              qtyInput.setAttribute('aria-label', 'Quantity');

              const btnIncrease = document.createElement('button');
              btnIncrease.type = 'button';
              btnIncrease.className = 'qty-increase';
              btnIncrease.setAttribute('aria-label', 'Increase quantity');
              btnIncrease.textContent = '+';

              qtySelector.appendChild(btnDecrease);
              qtySelector.appendChild(qtyInput);
              qtySelector.appendChild(btnIncrease);
              qtyRow.appendChild(qtyLabel);
              qtyRow.appendChild(qtySelector);

              // CTA buttons – productId set via setAttribute (safe)
              const safeProductId = String(productId).replace(/[^0-9a-zA-Z_-]/g, '');

              const ctaButtons = document.createElement('div');
              ctaButtons.className = 'cta-buttons';

              const btnAddToCart = document.createElement('button');
              btnAddToCart.type = 'button';
              btnAddToCart.className = 'btn-add-to-cart';
              btnAddToCart.setAttribute('data-product-id', safeProductId);
              btnAddToCart.textContent = 'ADD TO CART';

              const btnBuyNow = document.createElement('button');
              btnBuyNow.type = 'button';
              btnBuyNow.className = 'btn-buy-now';
              btnBuyNow.setAttribute('data-product-id', safeProductId);
              btnBuyNow.textContent = 'BUY IT NOW';

              ctaButtons.appendChild(btnAddToCart);
              ctaButtons.appendChild(btnBuyNow);

              // Message box
              const mobileMsg = document.createElement('div');
              mobileMsg.className = 'mobile-action-msg';

              actions.appendChild(qtyRow);
              actions.appendChild(ctaButtons);
              actions.appendChild(mobileMsg);

              popup.querySelector('.popup-scroll').appendChild(actions);
            }
          }
          
          // Auto-select first length option if available
          const firstLengthOption = popup.querySelector('[data-option="Length"] .custom-size-ul-value:first-child');
          if (firstLengthOption) {
            firstLengthOption.classList.add('selected');
          }
        } else {
          console.log(`Popup disabled for product ${productId} (no Size/Length values)`);
        }
      }
    });
  
    // Function to close popup
    function closePopup(popup, productId) {
      popup.style.display = 'none';
      popup.classList.remove('mobile-full', 'show');
      document.body.style.overflow = '';
      
      // Restore slider arrows for this product when popup is closed
      const productArrows = document.querySelectorAll(`.product-slider-nav[data-product-id="${productId}"]`);
      productArrows.forEach(arrow => {
        arrow.style.display = '';
        arrow.style.opacity = '';
        arrow.style.zIndex = '';
      });
      
      // Clear all selections when popup is closed
      popup.querySelectorAll('.custom-size-ul-value').forEach((el) => {
        el.classList.remove('selected');
      });
      // Clear error messages
      const msgBox = popup.querySelector('.error-success-msg');
      if (msgBox) {
        msgBox.textContent = '';
        msgBox.className = 'error-success-msg';
      }
      const mobileMsgBox = popup.querySelector('.mobile-action-msg');
      if (mobileMsgBox) {
        mobileMsgBox.textContent = '';
        mobileMsgBox.className = 'mobile-action-msg';
      }
    }
  
    // Use event delegation for popup close buttons
    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('popup-close')) {
        const productId = e.target.getAttribute('data-product-id');
        const popup = document.getElementById(`custom-popup-${productId}`);
        if (popup) {
          closePopup(popup, productId);
        }
      }
    });
  
    // Close popup on outside click (backdrop)
    window.addEventListener('click', function (e) {
      const popup = e.target.closest('.popup-overlay');
      if (popup) {
        const content = popup.querySelector('.popup-content');
        // Close if clicking on the overlay (backdrop), not on content inside
        if (popup.classList.contains('mobile-full') && e.target === popup) {
          // Mobile: close when clicking backdrop
          const productId = popup.getAttribute('id').replace('custom-popup-', '');
          closePopup(popup, productId);
        } else if (!popup.classList.contains('mobile-full') && e.target === popup) {
          // Desktop behavior
          const productId = popup.getAttribute('id').replace('custom-popup-', '');
          closePopup(popup, productId);
        }
      }
    });
  
    // ✅ SAFE getVariantId function
    function getVariantId(productId, selectedSize, selectedLength) {
      const variantEl = document.getElementById(`ProductVariants-${productId}`);
      if (!variantEl) return null;
  
      let variants = [];
      try {
        variants = JSON.parse(variantEl.textContent);
      } catch (err) {
        console.error('Invalid variant JSON for product', productId, err);
        return null;
      }
  
      if (!Array.isArray(variants)) {
        console.error('Variants is not an array for product', productId, variants);
        return null;
      }
  
      const match = variants.find((v) => {
        const sizeMatch = !selectedSize || v.option1 === (selectedSize?.textContent?.trim() || '');
        const lengthMatch = !selectedLength || v.option2 === (selectedLength?.textContent?.trim() || '');
        return sizeMatch && lengthMatch;
      });
  
  
  
      
      
      return match ? match.id : null;
    }
  
    document.addEventListener('DOMContentLoaded', function () {
      // Product image slider functionality
      function initProductSlider(productId) {
        const slider = document.querySelector(`[data-product-id="${productId}"] .product-image-slider`);
        if (!slider) return;
  
        const images = slider.querySelectorAll('.product-image');
        const prevBtn = document.querySelector(`.product-slider-prev[data-product-id="${productId}"]`);
        const nextBtn = document.querySelector(`.product-slider-next[data-product-id="${productId}"]`);
        const dots = document.querySelectorAll(`.product-slider-dot[data-product-id="${productId}"]`);
        
        if (images.length <= 1) return; // No need for slider if only one image
  
        let currentSlide = 0;
  
        function showSlide(index) {
          images.forEach((img, i) => {
            img.classList.toggle('active', i === index);
          });
          dots.forEach((dot, i) => {
            dot.classList.toggle('active', i === index);
          });
        }
  
        function nextSlide() {
          currentSlide = (currentSlide + 1) % images.length;
          showSlide(currentSlide);
        }
  
        function prevSlide() {
          currentSlide = (currentSlide - 1 + images.length) % images.length;
          showSlide(currentSlide);
        }
  
        function goToSlide(index) {
          currentSlide = index;
          showSlide(currentSlide);
        }
  
        // Event listeners
        if (nextBtn) nextBtn.addEventListener('click', nextSlide);
        if (prevBtn) prevBtn.addEventListener('click', prevSlide);
        
        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => goToSlide(index));
        });
  
        // Initialize first slide
        showSlide(0);
      }
  
      // Initialize all product sliders
      document.querySelectorAll('.product-image-slider').forEach(slider => {
        const productId = slider.getAttribute('data-product-id');
        if (productId) {
          initProductSlider(productId);
        }
      });
  
      // Size/Length selection highlight - use event delegation
      document.addEventListener('click', function (e) {
        if (e.target.classList.contains('custom-size-ul-value')) {
          // Prevent selection if the item is unavailable
          if (e.target.classList.contains('unavailable')) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          const parent = e.target.closest('.custom-size-ul');
          parent.querySelectorAll('.custom-size-ul-value').forEach((el) => el.classList.remove('selected'));
          e.target.classList.add('selected');
        }
      });
  
      document.addEventListener('click', function (e) {
        if (e.target.classList.contains('media__hovercustom-button')) {
          e.preventDefault();
          const popup = e.target.closest('.popup-overlay');
          const msgBox = popup.querySelector('.error-success-msg');
  
          msgBox.textContent = '';
          msgBox.className = 'error-success-msg';
  
  
          const selectedSize = popup.querySelector('[data-option="Size"] .custom-size-ul-value.selected');
          const selectedLength = popup.querySelector('[data-option="Length"] .custom-size-ul-value.selected');
          let errorMsg = '';
  
          console.log("Size:",selectedSize);
          console.log("Length:",selectedLength)
  
          if (popup.querySelectorAll('[data-option="Size"] .custom-size-ul-value').length && !selectedSize) {
            errorMsg = 'Please select a Size.';
          }
          if (popup.querySelectorAll('[data-option="Length"] .custom-size-ul-value').length && !selectedLength) {
            errorMsg = errorMsg ? 'Please select both Size and Length.' : 'Please select a Length.';
          }
  
          // Check if selected size or length is unavailable
          if (selectedSize && selectedSize.classList.contains('unavailable')) {
            errorMsg = 'Selected size is out of stock. Please select another size.';
          }
          if (selectedLength && selectedLength.classList.contains('unavailable')) {
            errorMsg = 'Selected length is out of stock. Please select another length.';
          }
  
          if (errorMsg) {
            msgBox.textContent = errorMsg;
            msgBox.classList.add('error');
            return;
          }
         
  
          const productId = popup.getAttribute('id').replace('custom-popup-', '');
  
          const variantId = getVariantId(productId, selectedSize, selectedLength);
          console.log('VariantId found:', variantId, 'for product', productId);
  
          if (!variantId) {
            msgBox.textContent = 'This variant is unavailable.';
            msgBox.classList.add('error');
            return;
          }
  
          const cartDrawer = document.querySelector('cart-drawer');
          const isProductPage = window.location.pathname.includes('/products/');
          
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          })
            .then((res) => res.json())
            .then((data) => {
              console.log('Added to cart:', data);
              msgBox.textContent = 'Product added successfully';
              msgBox.classList.add('success');
  
              // Update cart drawer and cart icon bubble
              if (cartDrawer) {
                // Use the existing onCartUpdate method which is proven to work
                const cartDrawerItems = document.querySelector('cart-drawer-items');
                if (cartDrawerItems && typeof cartDrawerItems.onCartUpdate === 'function') {
                  // This method properly refreshes the cart drawer
                  cartDrawerItems.onCartUpdate();
                }
                
                // Also update cart icon bubble separately
                setTimeout(() => {
                  fetch('/cart?section_id=cart-icon-bubble')
                    .then(r => r.text())
                    .then(bubbleHtml => {
                      const bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
                      const currentCartIcon = document.querySelector('#cart-icon-bubble');
                      if (currentCartIcon) {
                        let bubbleContent = null;
                        const bubbleShopifySection = bubbleDoc.querySelector('.shopify-section');
                        if (bubbleShopifySection) {
                          bubbleContent = bubbleShopifySection.innerHTML;
                        } else if (bubbleDoc.body) {
                          bubbleContent = bubbleDoc.body.innerHTML;
                        }
                        
                        if (bubbleContent) {
                          currentCartIcon.innerHTML = bubbleContent;
                        }
                        
                        // Re-attach event listeners
                        if (typeof cartDrawer.setHeaderCartIconAccessibility === 'function') {
                          cartDrawer.setHeaderCartIconAccessibility();
                        }
                      }
                    })
                    .catch(e => console.error('Error updating cart icon:', e));
                }, 300);
                
                // Remove is-empty class if present
                setTimeout(() => {
                  if (cartDrawer.classList.contains('is-empty')) {
                    cartDrawer.classList.remove('is-empty');
                  }
                  const updatedCartDrawerItems = document.querySelector('cart-drawer-items');
                  if (updatedCartDrawerItems && updatedCartDrawerItems.classList.contains('is-empty')) {
                    updatedCartDrawerItems.classList.remove('is-empty');
                  }
                  
                  // Trigger cart update event for other components
                  if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                    fetch('/cart.js')
                      .then(res => res.json())
                      .then(cartData => {
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                          source: 'quick-add',
                          cartData: cartData
                        });
                      })
                      .catch(e => console.error('Error fetching cart data:', e));
                  }
                  
                  // Open the cart drawer only on product pages
                  if (isProductPage) {
                    cartDrawer.open();
                  }
                }, 400);
              }
  
              const popup = document.getElementById(`custom-popup-${productId}`);
              if (popup) {
                popup.style.display = 'none';
                // Clear all selections after successful add to cart
                popup.querySelectorAll('.custom-size-ul-value').forEach((el) => {
                  el.classList.remove('selected');
                });
                const msgBox = popup.querySelector('.error-success-msg');
                if (msgBox) {
                  msgBox.textContent = '';
                  msgBox.className = 'error-success-msg';
                }
              }
            })
            .catch((err) => {
              console.log(err);
              msgBox.textContent = 'Failed to add product.';
              msgBox.classList.add('error');
            });
  
          const productTitle = popup.querySelector('.popup-title')?.textContent.trim() || 'Product';
          const productImage = popup.querySelector('.popup-product-info img')?.src || '';
          const productDescription = popup.querySelector('.popup-description')?.textContent.trim() || '';
          const productPrice = popup.querySelector('.popup-price')?.textContent.trim() || '';
          const productColour = popup.querySelector('.custom-color-ul-value')?.textContent.trim() || '';
  
          const fullOverlay = document.querySelector('.atc-popup-overlay');
          if (fullOverlay) {
            const atcPopup = fullOverlay.querySelector('.atc-popup');
            if (atcPopup) {
              atcPopup.innerHTML = ''; 

              const closeBtn = document.createElement('button');
              closeBtn.className = 'atc-popup-close';
              closeBtn.title = 'Close';
              closeBtn.innerHTML = '×';
              closeBtn.addEventListener('click', () => {
                fullOverlay.style.display = 'none';
              });
              atcPopup.appendChild(closeBtn);

              const successMsg = document.createElement('p');
              successMsg.className = 'success-msg';
              successMsg.innerHTML = '✓ Added to Bag for Ship';
              atcPopup.appendChild(successMsg);

              const contentWrapper = document.createElement('div');
              contentWrapper.className = 'popup-content-wrapper';

              const safeImgUrl = sanitizeImageUrl(productImage);
              if (safeImgUrl) {
                const img = document.createElement('img');
                img.src = safeImgUrl;
                img.alt = productTitle;
                img.className = 'popup-product-image';
                contentWrapper.appendChild(img);
              }

              const details = document.createElement('div');
              details.className = 'popup-product-details';

              const title = document.createElement('div');
              title.className = 'popup-product-title';
              title.textContent = productTitle;
              details.appendChild(title);

              const color = document.createElement('div');
              color.className = 'popup-product-color';
              color.textContent = productColour;
              details.appendChild(color);

              const price = document.createElement('div');
              price.className = 'popup-product-price';
              price.textContent = productPrice;
              details.appendChild(price);

              const sizeLengthContainer = document.createElement('div');
              sizeLengthContainer.className = 'sizeandlength';

              const sizeVal = selectedSize ? selectedSize.textContent.trim() : '';
              const lengthVal = selectedLength ? selectedLength.textContent.trim() : '';
              if (sizeVal || lengthVal) {
                const p = document.createElement('p');
                p.className = 'popup-product-sizeandlength';
                let text = '';
                if (sizeVal && lengthVal) text = `${sizeVal} S X ${lengthVal} L`;
                else if (sizeVal) text = `${sizeVal} S`;
                else if (lengthVal) text = `${lengthVal} L`;
                p.textContent = `${text}    Qty: 1`;
                sizeLengthContainer.appendChild(p);
              }
              details.appendChild(sizeLengthContainer);

              contentWrapper.appendChild(details);
              atcPopup.appendChild(contentWrapper);

              // Success box
              const successBox = document.createElement('div');
              successBox.className = 'success-box';
              atcPopup.appendChild(successBox);

              // Buttons
              const buttonsDiv = document.createElement('div');
              buttonsDiv.className = 'popup-buttons';

              const bagBtn = document.createElement('button');
              bagBtn.id = 'go-to-bag';
              bagBtn.className = 'custom-review';
              bagBtn.textContent = 'Review Bag';
              bagBtn.addEventListener('click', () => {
                window.location.href = '/cart';
              });
              buttonsDiv.appendChild(bagBtn);

              atcPopup.appendChild(buttonsDiv);
            }
            fullOverlay.style.display = 'flex';
          }
        }
      });
  
      // Quantity controls (event delegation)
      document.addEventListener('click', function (e) {
        const qtyButton = e.target.closest('.qty-increase, .qty-decrease');
        if (qtyButton) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          const actions = qtyButton.closest('.mobile-actions');
          if (!actions) return;
          
          const input = actions.querySelector('.qty-input');
          if (!input) return;
          
          const current = parseInt(input.value || '1', 10);
          if (isNaN(current) || current < 1) {
            input.value = 1;
            return;
          }
          
          if (qtyButton.classList.contains('qty-increase')) {
            input.value = current + 1;
          } else if (qtyButton.classList.contains('qty-decrease')) {
            input.value = Math.max(1, current - 1);
          }
        }
      }, { once: false, capture: false });
  
      // Mobile Add to Cart / Buy It Now buttons
      document.addEventListener('click', function (e) {
        if (e.target.classList.contains('btn-add-to-cart') || e.target.classList.contains('btn-buy-now')) {
          e.preventDefault();
          const productId = e.target.getAttribute('data-product-id');
          const popup = document.getElementById(`custom-popup-${productId}`);
          if (!popup) return;
          
          // Use message box below buttons
          const msgBox = popup.querySelector('.mobile-action-msg');
          if (msgBox) {
            msgBox.textContent = '';
            msgBox.className = 'mobile-action-msg';
          }
  
          const selectedSize = popup.querySelector('[data-option="Size"] .custom-size-ul-value.selected');
          const selectedLength = popup.querySelector('[data-option="Length"] .custom-size-ul-value.selected');
          const qtyInput = popup.querySelector('.qty-input');
          const quantity = Math.max(1, parseInt(qtyInput?.value || '1', 10));
  
          let errorMsg = '';
          if (popup.querySelectorAll('[data-option="Size"] .custom-size-ul-value').length && !selectedSize) {
            errorMsg = 'Please select a Size.';
          }
          if (popup.querySelectorAll('[data-option="Length"] .custom-size-ul-value').length && !selectedLength) {
            errorMsg = errorMsg ? 'Please select both Size and Length.' : 'Please select a Length.';
          }
          if (errorMsg && msgBox) {
            msgBox.textContent = errorMsg;
            msgBox.classList.add('error');
            // Scroll message into view
            setTimeout(() => {
              msgBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }, 100);
            return;
          }
  
          const variantId = getVariantId(productId, selectedSize, selectedLength);
          if (!variantId) {
            if (msgBox) {
              msgBox.textContent = 'This variant is unavailable.';
              msgBox.classList.add('error');
              setTimeout(() => {
                msgBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              }, 100);
            }
            return;
          }
  
          const isBuyNow = e.target.classList.contains('btn-buy-now');
  
          // For Buy It Now, redirect directly to checkout without adding to cart.
          // Strip variantId and quantity to digits only to prevent URL injection.
          if (isBuyNow) {
            const safeVariantId = String(variantId).replace(/[^0-9]/g, '');
            const safeQuantity  = Math.max(1, parseInt(quantity, 10) || 1);
            window.location.href = `/cart/${safeVariantId}:${safeQuantity}`;
            return;
          }
  
          // For Add to Cart, proceed with normal cart add flow
          const cartDrawer = document.querySelector('cart-drawer');
          
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity })
          })
            .then((res) => {
              if (!res.ok) {
                throw new Error('Failed to add to cart');
              }
              return res.json();
            })
            .then((data) => {
              // Verify the product was added successfully
              if (!data || data.status === 'ERROR') {
                throw new Error('Failed to add to cart');
              }
  
              // Update cart drawer and cart icon bubble
              if (cartDrawer) {
                // Use the existing onCartUpdate method which is proven to work
                const cartDrawerItems = document.querySelector('cart-drawer-items');
                if (cartDrawerItems && typeof cartDrawerItems.onCartUpdate === 'function') {
                  // This method properly refreshes the cart drawer
                  cartDrawerItems.onCartUpdate();
                }
                
                // Also update cart icon bubble separately
                setTimeout(() => {
                  fetch('/cart?section_id=cart-icon-bubble')
                    .then(r => r.text())
                    .then(bubbleHtml => {
                      const bubbleDoc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
                      const currentCartIcon = document.querySelector('#cart-icon-bubble');
                      if (currentCartIcon) {
                        let bubbleContent = null;
                        const bubbleShopifySection = bubbleDoc.querySelector('.shopify-section');
                        if (bubbleShopifySection) {
                          bubbleContent = bubbleShopifySection.innerHTML;
                        } else if (bubbleDoc.body) {
                          bubbleContent = bubbleDoc.body.innerHTML;
                        }
                        
                        if (bubbleContent) {
                          currentCartIcon.innerHTML = bubbleContent;
                        }
                        
                        // Re-attach event listeners
                        if (typeof cartDrawer.setHeaderCartIconAccessibility === 'function') {
                          cartDrawer.setHeaderCartIconAccessibility();
                        }
                      }
                    })
                    .catch(e => console.error('Error updating cart icon:', e));
                }, 300);
                
                // Remove is-empty class and trigger events
                setTimeout(() => {
                  if (cartDrawer.classList.contains('is-empty')) {
                    cartDrawer.classList.remove('is-empty');
                  }
                  const updatedCartDrawerItems = document.querySelector('cart-drawer-items');
                  if (updatedCartDrawerItems && updatedCartDrawerItems.classList.contains('is-empty')) {
                    updatedCartDrawerItems.classList.remove('is-empty');
                  }
                  
                  // Trigger cart update event for other components
                  if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                    fetch('/cart.js')
                      .then(res => res.json())
                      .then(cartData => {
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                          source: 'quick-add',
                          cartData: cartData
                        });
                      })
                      .catch(e => console.error('Error fetching cart data:', e));
                  }
                }, 400);
              }
              
              // Show success message
              if (msgBox) {
                msgBox.textContent = 'Product added successfully';
                msgBox.classList.add('success');
                // Scroll message into view
                setTimeout(() => {
                  msgBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }, 100);
              }
  
              // Close popup after showing success message
              setTimeout(() => {
                closePopup(popup, productId);
              }, 1500);
            })
            .catch((error) => {
              console.error('Error adding to cart:', error);
              if (msgBox) {
                msgBox.textContent = 'Failed to add product to cart. Please try again.';
                msgBox.classList.add('error');
                setTimeout(() => {
                  msgBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }, 100);
              }
            });
        }
      });
  
      // Close full overlay
      document.addEventListener('click', function (e) {
        if (e.target.classList.contains('atc-popup-close') || e.target.classList.contains('atc-popup-overlay')) {
          document.querySelector('.atc-popup-overlay').style.display = 'none';
        }
      });
  
    });
  })(); 